import { Select } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import uuidv4 from "uuid/v4";

const Option = Select.Option;

const DestinationFields = ({ onArticleChange, article, isAccountRow }) => {
  const destinations = useSelector(state => state.precog.vat.destinations);
  
  const [destinationVal, setDestinationVal] = useState(undefined);

  useEffect(() => {
    if (!article?.vatDestinationId) return;
    setDestinationVal(article.vatDestinationId);
  }, [article?.vatDestinationId]);

  return (
    <>
      <Select
        data-testid={"DestinationFields"}
        showSearch
        optionFilterProp="children"
        getPopupContainer={trigger => isAccountRow ? document.querySelector(".ant-table-tbody") : trigger.parentNode}
        filterOption={(input, option) => 
          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        onSelect={value => { onArticleChange("vatDestinationId", value); setDestinationVal(value); }}
        className={isAccountRow ? "articles-accordion-select" : "split-article-input"}
        value={destinationVal}
        placeholder="Sel. destinazione"
        style={{ width: isAccountRow ? "100%" : 250 }}
        dropdownClassName={isAccountRow ? "articles-accordion-dropdown" : "split-article-input-accordion"}
      >
        {destinations?.list.map(el => (
          <Option
            key={"articles-accordion-select_" + uuidv4()}
            value={el.id}
          >
            {el.description}
          </Option>
        ))}
      </Select>
    </>
  );

};

export default DestinationFields;
